//This slice will contain the logic to handle the password reset process of workers accounts.



//This slice is used to handle the password reset process of the business account.
//For worker accounts we will create a separate slice.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import passwordResetServiceWorker from './passwordResetServiceWorker' 

const initialState = {
    // verification is either pending or approved. 
    verification : {
        verificationStatus: "",
        token: ""
    },
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: '',
}

//Send verification code to worker phone
export const sendCode = createAsyncThunk('verifyWorker/sendCode', 
    async(phone, thunkAPI) =>{
        //thunkAPI to connect to backEnd 
        try {
            return await passwordResetServiceWorker.sendCodeService(phone)
        } catch (error) {
            const message = 
            (error.response && error.response.data && error.response.data.message) ||
            error.message ||
            error.toString()
                return thunkAPI.rejectWithValue(message)
        }
})




//verify code worker account.
export const verifyCode = createAsyncThunk('verifyWorker/verifyCode', 
    async(data, thunkAPI) =>{
        //thunkAPI to connect to backEnd 
        try {
            return await passwordResetServiceWorker.verifyCodeService(data)
        } catch (error) {
            const message = 
            (error.response && error.response.data && error.response.data.message) ||
            error.message ||
            error.toString()
                return thunkAPI.rejectWithValue(message)
        }
})

//updatePassword worker account.
//Reset the state after the password is changed.
export const changePassword = createAsyncThunk('resetPassword/' ,
    async(newPassword,thunkAPI) =>{
    try {
        //get the token from the state
        const token = thunkAPI.getState().workerPasswordReset.verification.token;
        return await passwordResetServiceWorker.submitNewPassword(newPassword, token)
    } catch (error) {
        const message = 
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString()
            return thunkAPI.rejectWithValue(message)
    }
})

export const workerPasswordResetSlice = createSlice ({
    name: 'workerPasswordReset',
    initialState,
    reducers:{

        reset: (state) => initialState,
        
    },

    extraReducers: (builder) =>{
        builder
            .addCase(sendCode.pending, (state) =>{
                state.isLoading = true
            
            })
            .addCase(sendCode.fulfilled, (state,action)=>{
                state.isLoading = false
                state.isSuccess = true
                state.verification = action.payload
                state.message = "Verification code sent"
            } )
            .addCase(sendCode.rejected, (state,action) =>{
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.isSuccess = false
            })


            .addCase(verifyCode.pending, (state) =>{
                state.isLoading = true
            })
            .addCase(verifyCode.fulfilled , (state,action)=>{
                state.isLoading = false
                state.verification = action.payload
                state.isSuccess = true
                state.message = "Code verified successfully, you can now reset your password."
            })
            .addCase(verifyCode.rejected, (state,action) =>{
                state.isLoading = false
                state.message = action.payload
                state.isError = true
                state.isSuccess = false
            })


            .addCase(changePassword.pending, (state) =>{
                state.isLoading = true
            })
            .addCase(changePassword.fulfilled , (state,action)=>{
                state.isLoading = false
                state.message = action.payload
                state.isSuccess = true
                state.message = "Password changed successfully"
            })
            .addCase(changePassword.rejected, (state,action) =>{
                state.isLoading = false
                state.message = action.payload
                state.isError = true
                state.isSuccess = false
            })
    }
   
})

export const{reset} = workerPasswordResetSlice.actions
export default workerPasswordResetSlice.reducer

